import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Adicionar", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-18" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Valor")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo ss-margin-campos" }, "Ativo")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" })
], -1)
const _hoisted_7 = { class: "ant-col ant-col-xs-2 ant-col-xl-1" }
const _hoisted_8 = {
  title: "Arraste para cima ou para baixo para ordenar os itens",
  class: "ss-mover ss-alinhar-centro"
}
const _hoisted_9 = { class: "ant-col ant-col-xs-22 ant-col-xl-17" }
const _hoisted_10 = { class: "ss-margin-campos" }
const _hoisted_11 = { class: "ant-col ant-col-xs-21 ant-col-xl-5" }
const _hoisted_12 = { class: "ss-margin-campos" }
const _hoisted_13 = { class: "ant-col ant-col-xs-2 ant-col-xl-1 ss-linhar-centro" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, { titulo: "ITENS" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_a_form_item, {
                  label: "Novo valor",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      ref: "campoNovoValor",
                      type: "text",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.novoValor) = $event)),
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.adicionarItem()), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.state.novoValor]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_form_item, {
                  label: " ",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-primary ant-btn-block",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.adicionarItem()))
                    }, _hoisted_5)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _hoisted_6,
        (_ctx.computedItensListaSimples.length <= 0)
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              mensagem: "Nenhum item foi adicionado ainda"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form, {
          name: "ss-form-caracteristica-itens-lista-simples",
          class: "ss-altura-rolagem-padrao",
          model: _ctx.computedItensListaSimples
        }, {
          default: _withCtx(() => [
            _createVNode(_component_draggable, {
              modelValue: _ctx.computedItensListaSimples,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedItensListaSimples) = $event)),
              "item-key": "index",
              handle: ".ss-mover"
            }, {
              item: _withCtx(({element,index}) => [
                (_openBlock(), _createElementBlock("div", {
                  class: "ant-row ss-grade-personalizada-linha",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_icone, {
                        style: {"font-size":"15px"},
                        nome: "ordenar-lista"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_a_input, {
                        class: "ant-input",
                        value: element.valor,
                        "onUpdate:value": ($event: any) => ((element.valor) = $event)
                      }, null, 8, ["value", "onUpdate:value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_selecionar_sim_nao, {
                        valor: element.ativo,
                        "onUpdate:valor": ($event: any) => ((element.ativo) = $event)
                      }, null, 8, ["valor", "onUpdate:valor"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("a", {
                      title: "Remover",
                      onClick: ($event: any) => (_ctx.removerItem(index))
                    }, [
                      _createVNode(_component_icone, { nome: "excluir" })
                    ], 8, _hoisted_14)
                  ])
                ]))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ]))
}